<kendo-dialog *ngIf="isEditing()" title="Download & Unlock" width="800px" (close)="this.close()">
    <div class="wrapper">
        <table>
            <tr>
                <th>File</th>
                <th>Last Modified</th>
            </tr>
            @for (f of this.filesToWatch; track f) {
                @let lastDate = this.getLastDate(f);
            <tr>
                <td>
                    @let split = f.split('/');
                    @let fName = split[split.length - 1];
                    @if (lastDate != undefined) {
                        <a class="link" (click)="this.download(f)">{{fName}}</a>
                    } @else  {
                        {{fName}}
                    }
                    
                </td>
                <td>{{lastDate != undefined ? lastDate : "N/A" }}</td>
            </tr>
            }
            <tr>
                <td colspan="2">
                    <a class="link" (click)="this.downloadAll()">Download All</a>
                </td>
            </tr>
        </table>
        <kendo-textarea
                    placeholder="Opmerking..."
                    [rows]="3"
                    [(value)]="this.opmerking"
                    resizable="vertical"
                    ></kendo-textarea>
        @if (this.serverApi.isSercom() && !this.jsBridgeService.isSercomKlant()) {
            <div>
                <kendo-checkbox @unclokAsSercom [(ngModel)]="this.unlockAsSercom"></kendo-checkbox>
                <kendo-label [for]="unlockAsSercom" [textContent]="'Unlock as Sercom'">
                </kendo-label>

            </div>
            @if (!this.unlockAsSercom) {
                <div [style]="{width: '500px'}">
                    <kendo-label text="Uren">

                    </kendo-label>
                    <kendo-textbox
                                placeholder="Uren"
                                [(value)]="this.uren"
                                style="width: 100px;"
                                ></kendo-textbox>
                </div>

            }
        }
        <button kendoButton *ngIf="this.canWrite" [disabled]="this.disableUnlock" (click)="this.unlock()" [themeColor]="'primary'">Unlock</button>
        <pre [class.error]="this.unlockError">{{unlockResult}}</pre>

    </div>
    <kendo-dialog-actions>
        <button kendoButton (click)="this.close()">Close</button>
    </kendo-dialog-actions>
</kendo-dialog>